import React from 'react';

const PROGRAMME = [
    'Free deal management platform, application to IC',
    'Application triage in 3–4 minutes, no cost',
    'Cohort dashboard — readiness, risk, certification, live',
    'Sponsor reporting your team no longer has to chase',
];

const COHORT = [
    'Diligence Pack, up to 60% auto-populated from documents',
    'Corporate, financial, and technical reverse-diligence',
    'Bronze / Silver / Gold certification investors recognise',
    '1-click InvestorMatch to 40+ active VCs',
];

const EcosystemMark = () => (
    <svg width="30" height="30" viewBox="0 0 40 40" fill="none" aria-hidden="true">
        <path d="M4 26L13 15L19 22L24 16" stroke="#FC7785" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19 22L24 16L36 9" stroke="#4A67FF" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// `onSeeCohort` switches the page to the Cohort Companies tab — the design wires this button to its
// own switchTab('3'), so it stays an in-page tab change rather than a link.
const AccOnePlatformSection = ({ onSeeCohort }) => (
    <section className="lp-acc-sec">
        <div className="lp-acc-wrap">
            <span className="lp-acc-kicker" data-lp-reveal>Our Differentiator</span>
            <h2 className="lp-acc-h2" data-lp-reveal data-lp-delay="60">You are joining one integrated ecosystem.</h2>
            <p className="lp-acc-sub" data-lp-reveal data-lp-delay="120">Other tools help a VC screen deal flow. Others help a founder build a data room. Diligentsia is the one platform where your deal management, your cohort's investor readiness, and your follow-on investors' diligence all run on the same rails — so nothing gets lost in translation between them.</p>

            <div className="lp-acc-banner" data-lp-reveal data-lp-delay="160">
                <div className="lp-acc-banner-col">
                    <h3>For your programme</h3>
                    <ul>{PROGRAMME.map(t => <li key={t}>{t}</li>)}</ul>
                </div>
                <div className="lp-acc-banner-mid">
                    <div className="badge"><EcosystemMark /></div>
                    <span>One Ecosystem</span>
                </div>
                <div className="lp-acc-banner-col">
                    <h3>For your cohort</h3>
                    <ul>{COHORT.map(t => <li key={t}>{t}</li>)}</ul>
                </div>
            </div>

            <div className="lp-acc-center-cta" data-lp-reveal>
                <button type="button" className="lp-acc-btn lp-acc-btn--outline" onClick={onSeeCohort}>See what your cohort gets →</button>
            </div>
        </div>
    </section>
);

export default AccOnePlatformSection;
